<style lang="scss" src='./StationChart.scss' scoped></style>
<template src="./StationChart.html"></template>

<script>
import ApexChart from 'vue-apexcharts';
import {
    getStationGraph,
  } from '@/api/api';

let CounterForUpdates = 0;

export default {
  name: 'StationChart',
  props: {
    station:{
      required: false,
    },

    alert: {
      requiered: false,
    },
  },
  
  components: {
      ApexChart,
  },

  data() {
    return ({
      loading: true,
      filters: {
        daysBack: null,
        chartType: null,
      },
      series: [{
          data: []
      }],
      options: [
          { text: this.$t('timePeriods.1D'), label: this.$t('timePeriods.last24H'), value: 1, },
          { text: this.$t('timePeriods.2D'), label: this.$t('timePeriods.last2D'), value: 2, },
          { text: this.$t('timePeriods.1W'), label: this.$t('timePeriods.lastWeek'), value: 7, },
          { text: this.$t('timePeriods.1M'), label: this.$t('timePeriods.lastMonth'), value: 30, },
          { text: this.$t('timePeriods.1Y'), label: this.$t('timePeriods.lastYear'), value: 365, },
        ],
      charOpt: {
          xaxis: {
            type: 'datetime',
          },
        },
      chartTypes: [
      ]
    });
  },
  computed: {
    noDataMessage() {
      return `${this.$t('timePeriods.noDataToShow')} ${this.filters.daysBack.label.toLowerCase()}`;
    },
  },
  watch: {
    sensor: function (newSensor, oldSensor) {
      if (newSensor && oldSensor && newSensor.sensor_id !== oldSensor.sensor_id) {
        this.loadData();
      }
    },
    station: function (newStation, oldStation) {
      if (newStation && oldStation && newStation.station_id !== oldStation.station_id) {
        this.loadData();
      }
    }
  },

  methods: {

    filterByDays(daysBack){
      this.filters.daysBack = daysBack;
      this.getGraph();
    },

    async getGraph() {
        this.loading = true;
        let tempChartOptions = this.getChartOptions();
        this.alertType = this.filters.chartType;

        this.unitOfMeasurament = this.G_getUOM({
          uom: this.alertType ? this.alertType.uom : this.alert.alert_type.uom
        });
        tempChartOptions.title.text = '';
        tempChartOptions.yaxis.title.text = this.unitOfMeasurament;

        const data = {
          sensorId: this.sensor && this.sensor.sensor_id,
          alias: this.alertType.alias,
          until: this.filters.daysBack.value,
          device_sn: this.station && this.station.device_sn,
          resampleFreq: this.filters.daysBack.value == 365 ? '8h' : null
        };

        let tempMin = null;
        let tempMax = null;
        let apiCall = apiCall = getStationGraph;

        await apiCall(data).then((res) => {
          let tempSeries = [];
          if (res.length > 0) {

            tempSeries = res.map((item) => {
              let reading = this.G_getMeasurement({
                  val: item[data.alias],
                  uom: this.alertType.uom,
                  addUnit: false,
                  invertUOM: false
                })
              if (tempMin == null) {
                tempMin = Number(reading);
              } else {
                if (Number(reading) < Number(tempMin)) {
                  tempMin = Number(reading);
                }
              }
              if (tempMax == null) {
                tempMax = Number(reading);
              } else {
                if (Number(reading) > Number(tempMax)) {
                  tempMax = Number(reading);
                }
              }
              return [
                new Date(item.reading_time).getTime(),
                reading
              ]
            });
          }
          this.series = [{
            name: this.$t(this.alertType.i18n),
            data: tempSeries
          }];
        });
        let min = null;
        let max = null;
        
        if (this.station && this.station.thresholds) {
          const threshold = this.station.thresholds.find(t => t.alert_type_id === this.alertType.id);
          const maxTh = threshold.max ? this.G_getMeasurement({ val: threshold.max, uom: threshold.alert_type.uom }): null;
          const maxVal = threshold.alert_type.max ? this.G_getMeasurement({ val: threshold.alert_type.max, uom: threshold.alert_type.uom }): null;
          const minTh = threshold.min ? this.G_getMeasurement({ val: threshold.min, uom: threshold.alert_type.uom }): null;
          const minVal = threshold.alert_type.min ? this.G_getMeasurement({ val: threshold.alert_type.min, uom: threshold.alert_type.uom }): null;
          min = minTh;
          max = maxTh;

          if (min) {
            tempChartOptions.annotations.yaxis[0].y = min;
            tempChartOptions.annotations.yaxis[0].label.text = 'Min ' + min + this.unitOfMeasurament
            if(max){
              tempChartOptions.annotations.yaxis[1].y = max;
              tempChartOptions.annotations.yaxis[1].label.text = 'Max ' + max + this.unitOfMeasurament;
            }else{
              tempChartOptions.annotations.yaxis[1] = null;
            }
          }else if(max){
            tempChartOptions.annotations.yaxis[0].y = max;
            tempChartOptions.annotations.yaxis[0].label.text = 'Max ' + max + this.unitOfMeasurament
            tempChartOptions.annotations.yaxis[1] = null;
          }else{
            tempChartOptions.annotations.yaxis[0] = null;
            tempChartOptions.annotations.yaxis[1] = null;
          }
          
        } else {
          min = 0;
          max = 0;
          tempChartOptions.annotations.yaxis = [];
        }

        let yaxisMin = (min < tempMin) ? min : tempMin;
        tempChartOptions.yaxis.min = (yaxisMin > 0) ? 0 : yaxisMin;
        if (tempMax > max) {
          tempChartOptions.yaxis.max = tempMax;
        } else {
          if (tempChartOptions.yaxis.min == 0 && max == 0) {
            max = 1;
          }
          tempChartOptions.yaxis.max = max;
        }

        this.charOpt = tempChartOptions;
        this.loading = false;
    },

    getChartOptions() {
        return {
          chart: {
            type: 'area',
            animations: {
              enabled: false,
            },

            stacked: false,
            height: 350,
            zoom: {
              type: 'x',
              enabled: true,
              autoScaleYaxis: true
            },
            toolbar: {
              show: false,
            },
            events: {
              updated: function (chartContext, config) {
                if (CounterForUpdates != 0) {
                  var elmnt = document.getElementById("chart");
                  if (elmnt) {
                    elmnt.scrollIntoView();
                  }
                }
                ++CounterForUpdates;
              }
            }
          },
          dataLabels: {
            enabled: false
          },
          // markers: {
          //   size: 0,
          //   colors: '#018ffb',
          //   strokeColors: '#018ffb',
          //   strokeWidth: 0,
          // },
          title: {
            text: 'title',
            align: 'left'
          },
          fill: {
            type: 'gradient',
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.4,
              opacityTo: 0,
              stops: [0, 90, 100]
            },
          },
          stroke: {
            width: [3]
          },
          yaxis: {
            labels: {
              formatter: function (val) {
                return val ? (val).toFixed(2) : 0;
              },
            },
            title: {
              text: 'unitOfMeasurament'
            },
            min: -5,
            max: 150,
          },
          xaxis: {
            type: 'datetime',
            labels: {
              datetimeUTC: false,
              datetimeFormatter: {
                year: 'yyyy',
                month: "MMM 'yy",
                day: 'dd MMM',
                hour: 'h:mm TT',
              },
            }
          },
          tooltip: {
            x: {
              show: true,
              formatter: (val) => {
                return this.G_formatDate({date: val, pretty: false});
              }
            },
            shared: false,
            y: {
              formatter: (val) => {
                return val ? `${(val).toFixed(2)}${this.unitOfMeasurament}` : '';
              }
            }
          },
          annotations: {
            yaxis: [{
              y: 10,
              borderColor: 'red',
              label: {
                borderColor: 'red',
                style: {
                  color: '#fff',
                  background: 'red',
                },
                text: 'Min',
              }
            }, {
              y: 60,
              borderColor: 'red',
              label: {
                borderColor: 'red',
                style: {
                  color: '#fff',
                  background: 'red',
                },
                text: 'Max',
              }
            }, ],
          }
        }
      },

    loadData() {
      if (this.station){
        this.getGraph();
      }
    },
  },

  beforeCreate() {},

  created() {},

  mounted() {
    const selectArray =[
        this.consts.AlertType.AIR_TEMPERATURE,
        this.consts.AlertType.BAROMETRIC_PRESSURE,
        this.consts.AlertType.HORIZONTAL_WIND_SPEED,
        this.consts.AlertType.LIGHTNING_STRIKE,
        this.consts.AlertType.PRECIPITATION,
        this.consts.AlertType.RELATIVE_HUMIDITY,
        this.consts.AlertType.WIND_GUST,
        this.consts.AlertType.ET_RATE,
    ];
    
    this.chartTypes = [...selectArray];
    this.filters.daysBack = this.options[0];
    this.filters.chartType = selectArray[0];

    this.getGraph();
  },
};
</script>
